import { FC, SVGProps } from 'react'
import cn from 'classnames'

import styles from './index.module.css'

type TIconDirection = 'up' | 'down' | 'left' | 'right'

type TIconProps = SVGProps<SVGSVGElement> & {
  active?: boolean
  direction?: TIconDirection
}

export const ControlIcon: FC<TIconProps> = ({ active, direction = 'down', ...props }) => {
  return (
    <svg
      className={cn(styles.icon, styles[direction], { [styles.active]: active })}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7072 7.29335L6.70657 3.29264C6.31623 2.90245 5.68309 2.90245 5.29275 3.29264C4.90242 3.68283 4.90242 4.31601 5.29275 4.70721L8.58653 8.00013L5.29275 11.293C4.90242 11.6832 4.90242 12.3164 5.29275 12.7076C5.48741 12.9022 5.74353 13 5.99966 13C6.25476 13 6.51089 12.9022 6.70657 12.7076L10.7072 8.7069C11.0976 8.31671 11.0976 7.68354 10.7072 7.29335Z"
        fill="currentColor"
      />
    </svg>
  )
}
